import React from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import DashboardSidebar from '../components/DashboardSidebar';
import GlossaryPanel from '../components/GlossaryPanel';

const GlossaryScreen = () => {
  const { palette } = useTheme();

  return (
    <View style={styles.container}>
      <View style={styles.layoutRow}>
        {/* Sidebar */}
        <DashboardSidebar currentPage="glossary" />

        {/* Main Content */}
        <ScrollView style={styles.mainCol} contentContainerStyle={styles.contentContainer}>
          <View style={styles.glossaryWrapper}>
            <GlossaryPanel style={{ maxHeight: 'none', borderWidth: 0 }} />
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 48,
    paddingRight: 48,
    paddingTop: 160,
    paddingBottom: 40,
    minHeight: '100vh',
  },
  layoutRow: {
    alignSelf: 'stretch',
    flexDirection: 'row',
    gap: 24,
  },
  mainCol: {
    flex: 1,
  },
  contentContainer: {
    paddingBottom: 40,
  },
  glossaryWrapper: {
    maxWidth: 900,
    width: '100%',
  },
});

export default GlossaryScreen;

